import client from "./client";

export interface RabbitMqConfig {
  username: string;
  password: string;
}

export async function getRabbitMqConfig(): Promise<RabbitMqConfig> {
  // Served by room-stc (migrated from main-api; same path and JSON).
  const res = await client.get<{ result: RabbitMqConfig }>(
    "/room/api/settings/rabbitmq",
  );
  return res.data.result;
}

export interface PersonalSettings {
  openDoor: boolean;
  enableChat: boolean;
  joinGroupOpen: boolean;
  onlyICanUpload: boolean;
}

export async function getPersonalSettings(): Promise<PersonalSettings> {
  const res = await client.get<{ result: PersonalSettings }>(
    "/api/personal-settings",
  );
  return res.data.result;
}

export async function updatePersonalSettings(
  settings: PersonalSettings,
): Promise<void> {
  await client.put("/api/personal-settings", settings);
}

export async function getStcChatSettings(
  stcId: number,
): Promise<PersonalSettings> {
  const res = await client.get<{ result: PersonalSettings }>(
    `/api/chat-settings/stc/${stcId}`,
  );
  return res.data.result;
}
